
import { defineComponent, ref } from 'vue';

import { onClickOutside } from '@vueuse/core';

import UserInfoDropdownMenu from '@hems/component/src/dropdown/user/UserInfoDropdownMenu.vue';
import Image from '@hems/component/src/image/Image.vue';
import { useHomeownerInfo } from '@hems/util/src/composable/homeownerInfo';
import { useLanguage } from '@hems/util/src/composable/language';
import type { LanguageValue } from '@hems/util/src/constant/languages';

import DropdownMenu from '@/components/header/DropdownMenu.vue';

export default defineComponent({
  name: 'Header',
  components: { Image, DropdownMenu, UserInfoDropdownMenu },
  props: {
    isLogin: {
      type: Boolean,
      default: false,
    },
    showMenu: {
      type: Boolean,
      default: true,
    },
  },
  emits: ['logout', 'changeLanguage'],
  setup(_props, { emit }) {
    const { languageCode, languageOptionsForManagement } = useLanguage();

    const languageMenuRef = ref<null | HTMLDivElement>(null);

    const selectedLanguage = ref<LanguageValue>(languageCode.value);

    const languageDropdownItems = languageOptionsForManagement.value;

    const ACCOUNT_MENU = {
      ACCOUNT_INFO: 'account_info',
      LOGOUT: 'logout',
    } as const;

    const { homeOwnerInfo } = useHomeownerInfo();

    const isOpenLanguageMenu = ref(false);
    const isOpenAccountMenu = ref(false);

    const toggleLanguageMenu = () => {
      isOpenLanguageMenu.value = !isOpenLanguageMenu.value;

      if (isOpenLanguageMenu.value && isOpenAccountMenu.value) {
        isOpenAccountMenu.value = false;
      }
    };

    const toggleAccountMenu = () => {
      isOpenAccountMenu.value = !isOpenAccountMenu.value;

      if (isOpenAccountMenu.value && isOpenLanguageMenu.value) {
        isOpenLanguageMenu.value = false;
      }
    };

    const onClickLanguage = (value: LanguageValue) => {
      selectedLanguage.value = value;

      isOpenLanguageMenu.value = false;

      emit('changeLanguage', selectedLanguage.value);
    };

    const onClickAccountMenu = (value: string) => {
      switch (value) {
        case ACCOUNT_MENU.LOGOUT:
          emit('logout');
          break;

        default:
          break;
      }

      isOpenAccountMenu.value = false;
    };

    onClickOutside(languageMenuRef, (event: Event) => {
      if (event.target instanceof HTMLImageElement) {
        return;
      }

      isOpenLanguageMenu.value = false;
    });

    return {
      languageMenuRef,
      isOpenLanguageMenu,
      isOpenAccountMenu,
      selectedLanguage,
      languageDropdownItems,
      toggleLanguageMenu,
      toggleAccountMenu,
      onClickLanguage,
      onClickAccountMenu,
      homeOwnerInfo,
    };
  },
});
